/*
  EGODRIFT Mobile Menu
  Version: 3.4.0 — 2026-07-19
  Last change: measure real drawer height on open (--ego-mm-height) so the
  utility footer (login/localization) always stays on-screen.
*/

document.addEventListener('DOMContentLoaded', () => {
  const menus = document.querySelectorAll('[data-ego-mobile-menu]');

  menus.forEach((menu) => {
    const toggle = menu.querySelector('[data-ego-mobile-menu-toggle]');
    const drawer = menu.querySelector('[data-ego-mobile-menu-drawer]');
    const overlay = menu.querySelector('[data-ego-mobile-menu-close]');
    const panelButtons = menu.querySelectorAll('[data-ego-mobile-menu-open-panel]');
    const backButtons = menu.querySelectorAll('[data-ego-mobile-menu-back]');
    const panels = menu.querySelectorAll('[data-ego-mobile-menu-panel]');
    const mainPanel = menu.querySelector('[data-ego-mobile-menu-panel="main"]');
    const predictiveSearch = menu.querySelector('predictive-search');
    const searchInput = menu.querySelector('[data-ego-mobile-menu-search] input[type="search"]');

    if (!toggle || !drawer || !mainPanel) return;

    const setDrawerHeight = () => {
      // The CSS height formula's --header-bottom-position is never set by
      // this custom menu (it was a stock header-drawer contract), so the
      // fallback ignored the announcement/callout above the header and the
      // utility footer (login, future locale/currency) overflowed the
      // screen. Measure the real available space instead.
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const anchor = drawer.offsetParent || menu;
      const top = anchor.getBoundingClientRect().bottom;
      menu.style.setProperty('--ego-mm-height', Math.max(viewportHeight - top, 200) + 'px');
    };

    const setOpen = (isOpen) => {
      if (isOpen) setDrawerHeight();
      menu.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('ego-mobile-menu-open', isOpen);

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (!isOpen) {
        predictiveSearch?.close?.();
        searchInput?.blur();
        showMainPanel();
        menu.querySelectorAll('.ego-mobile-menu__accordion[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    };

    const showPanel = (panelName) => {
      panels.forEach((panel) => {
        const isTarget = panel.dataset.egoMobileMenuPanel === panelName;

        panel.classList.toggle('is-active', isTarget);
        panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      });

      menu.classList.toggle('has-active-panel', panelName !== 'main');
    };

    const showMainPanel = () => {
      showPanel('main');
    };

    toggle.addEventListener('click', () => {
      setOpen(!menu.classList.contains('is-open'));
    });

    overlay?.addEventListener('click', () => {
      setOpen(false);
    });

    panelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panelName = button.dataset.egoMobileMenuOpenPanel;

        if (!panelName) return;

        predictiveSearch?.close?.();
        searchInput?.blur();
        showPanel(panelName);
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMainPanel();
      });
    });

    menu.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || !menu.contains(link)) return;

      setOpen(false);
    });

    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      if (!menu.classList.contains('is-open')) return;

      setOpen(false);
      toggle.focus();
    });

    const onViewportChange = () => {
      if (menu.classList.contains('is-open')) setDrawerHeight();
    };
    window.addEventListener('resize', onViewportChange);
    window.visualViewport?.addEventListener('resize', onViewportChange);
    window.addEventListener('scroll', onViewportChange, { passive: true });

    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) {
        setOpen(false);
      }
    });
  });
});